var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-center",class:_vm.classes},[_c('span',[_vm._v(_vm._s(_vm.$t('footer.derechos'))+" - "),_c('a',{attrs:{"href":"https://smartquick.ai/","target":"_blank","rel":"nofollow"}},[_vm._v("Quick © "+_vm._s(new Date().getFullYear())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }